import React from 'react';
import { Text } from '@marvelapp/ui';
export default function SpecsPanelLabel(_a) {
    var children = _a.children;
    return (React.createElement(Text, { as: "h5", color: "slate", fontSize: 1, marginBottom: 1 }, children));
}
